
import { Clipboard } from '@angular/cdk/clipboard';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Annotation } from '../../common/models/Annotation';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { ConfirmDialogComponent } from '../../common/shared-components/confirm-dialog/confirm-dialog.component';
import { constObj } from '../../common/Constants/constants';
import { HttpcallService } from '../../common/services/httpcall.service';
import { SessionService } from '../../common/services/Session.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-annotations',
  templateUrl: './my-annotations.component.html',
  styleUrls: ['./my-annotations.component.css']
})

export class MyAnnotationsComponent implements OnInit {
  public displayedColumns = ['AnnotationTitle', "Annotation", 'ParagraphId', 'Date', 'Action'];
  public dataSource = new MatTableDataSource<myAnnotations>();
  res: myAnnotations[];
  todaysDate: Date = new Date("2019-01-16");
  paragraphId: string = "";
  currentRoute: string;

  emailId: string;
  pagesize: any = 10;
  actualresult: any;
  pagelistarray: number[] = [];
  Annotationheader: any;
  annotationcolumnone: any;
  annotationcolumntwo: any;
  annotationcolumnthree: any;
  annotationcolumnfour: any;
  annotationcolumnfive: any;
  annotationContent: any = [];
  AnotationLocation: any;
  navData = {
    crumbData: [],
    menuData: [],
  }
  noRecords = constObj.Norecords;

  outcome: boolean = false;
  private paginator: MatPaginator;
  private sort: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    private graphqlService: GraphqlService, private httpCallService: HttpcallService, private session: SessionService, private route: Router,
    public commonDataService: CommonDataService, private loginService: LoginService, private clipboard: Clipboard, private graphQlService: GraphqlService, public dialog: MatDialog) { }
  ngOnInit() {
   
    //this.getAllOwners();
    this.commonDataService.myannotation.subscribe(data => {
      if (data == "annotations") {
        this.commonDataService.showLoader.next(true);
        this.getAnnotationsData();
      }
    })

    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.getAnnotationCall(data);
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.getAnnotationCall(this.session.userInfo);
    }
  }

  getAnnotationCall(data) {
    this.emailId = data.user.email;
    this.commonDataService.emailId.next(data.user.email);

    this.graphQlService.getGlobalLabels().subscribe(annotationLabel => { this.mapMyAnnotationsLabel(annotationLabel); })
    this.httpCallService.getAnnotation(this.paragraphId, "true").subscribe((annotation) => { this.mapAnnotationsData(annotation); this.outcome = true; this.commonDataService.showLoader.next(false); }, err => {
      let obj = {
        type: 'error',
        displayTime: 10000,
        position: 'bottom',
        message: constObj.microserviceFailureOnMyAnnotation
      }
      this.commonDataService.notificationObject.next(obj);
      this.outcome = true;
      console.log(err); this.commonDataService.showLoader.next(false);
    });
  }

  getAnnotationsData() {
    this.httpCallService.getAnnotation(this.paragraphId, "true").subscribe((resp: any) => {
      this.mapAnnotationsData(resp);
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }


  mapMyAnnotationsLabel(data) {
    if (data != "") {
      var labels = data.content.data.labels;
      labels = labels.filter(x => x.key.trim());
      this.Annotationheader = labels.filter(x => x.key == "myAnnotations_header").map(y => y.value);
      this.annotationcolumnone = labels.filter(x => x.key == "myBookmarks_columnOne").map(y => y.value);
      this.annotationcolumntwo = labels.filter(x => x.key == "global_annotation").map(y => y.value);
      this.annotationcolumnthree = labels.filter(x => x.key == "global_location").map(y => y.value);
      this.annotationcolumnfour = labels.filter(x => x.key == "global_date").map(y => y.value)[0];
      this.annotationcolumnfive = labels.filter(x => x.key == "global_action").map(y => y.value);
    }
  }
  public copyToClipboard = (id: string, URL: string, Annotationdesc: string, location1: string[]) => {
    let BreadcrumbLocation = location1.join(' -> ')
    if ((!URL?.startsWith("/") && URL.split("/").length < 3) || (URL?.startsWith("/") && URL.split("/").length <= 3)){
     URL="/"+URL.split("/")[1]+"/"+URL.split("/")[2]+"/"+location1[location1.length-1];
    }
    this.clipboard.copy("Annotation: " + Annotationdesc + "\nLink: " + location.origin + URL + "\nLocation: " + BreadcrumbLocation);
    let obj = {
      type: 'success',
      displayTime: 5000,
      position: 'bottom',
      message: constObj.linkSharedMessage
    }
    this.commonDataService.notificationObject.next(obj);
  }
  redirectToDelete(id: string) {
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: constObj.annotationDeletionConfirmationPromptMessage
    });
    var annotation = this.actualresult.filter(x => x.id == id)[0];
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.commonDataService.isConfirmationPopUpOpen.next(false);
        this.commonDataService.showLoader.next(true);
        var deleteAnnotation: Annotation = {
          id: annotation.id, topicId: annotation.topicId, paragraphId: annotation.paragraphId, annotationTitle: annotation.annotationTitle,
          annotationDescription: annotation.annotationDescription, 
          application: "", createdOn: annotation.createdOn, modifiedOn: "", breadCrumb: annotation.breadCrumb, isDeleted: true, annotationsURL: annotation.annotationsURL, area: annotation.area, navigationPath: annotation.navigationPath
        }
        this.httpCall(deleteAnnotation);
      }
    });
  }

  mapAnnotationsData(resp) {
    this.annotationContent = resp;
    this.actualresult = resp;
    if (this.actualresult[0]) {
      this.AnotationLocation = this.actualresult[0].breadCrumb;
    }
    let ress = this.actualresult.map(x => ({ id: x.id, AnnotationTitle: unescape(x.annotationTitle), Annotation: unescape(x.annotationDescription), Location: x.breadCrumb.split("~"), Date: new Date(x.createdOn), ParagraphId: x.paragraphId, AnnotationsURL: x.annotationsURL }))
    for (let i = 5; i <= 20; i = i + 5) {
      this.pagelistarray.push(i);
    }

    this.dataSource.data = ress as unknown as myAnnotations[];
    this.commonDataService.showLoader.next(false);
  }

  httpCall(annotation: Annotation) {
    this.httpCallService.addUpdateAnnotation(annotation).toPromise()
      .then(response => {
        if (response == "Annotation added successfully.") {
          let obj = {
            type: 'success',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.annotationRemovedSuccessMessage
          }
          this.commonDataService.notificationObject.next(obj);
          this.commonDataService.deleteAnnotationParagraphId.next(annotation.paragraphId);
          this.removeAnnotationFromArray(annotation);
        }
        else {
          let obj = {
            type: 'error',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.annotationRemovedFailMessage
          }
          this.commonDataService.notificationObject.next(obj);
          //this.removeAnnotationFromArray(annotation);
        }
      })
      .catch(res => {
        console.log(res);
        this.commonDataService.showLoader.next(false);
      });
  }
  removeAnnotationFromArray(annotation: Annotation) {
    this.annotationContent = this.annotationContent.filter(x => x.id != annotation.id);
    var ress = this.annotationContent.map(x => ({ id: x.id, AnnotationTitle: unescape(x.annotationTitle), Annotation: unescape(x.annotationDescription), Location: x.breadCrumb.split("~"), Date: new Date(x.createdOn), ParagraphId: x.paragraphId, AnnotationsURL: x.annotationsURL }))
    for (let i = 5; i <= 20; i = i + 5) {
      this.pagelistarray.push(i);
    }
    this.dataSource.data = ress as unknown as myAnnotations[];
    this.commonDataService.showLoader.next(false);
  }

  editAnnotations(id: string) {
    var annotation = this.annotationContent.filter(x => x.id == id);
    annotation[0].annotationDescription = unescape(annotation[0].annotationDescription);
    annotation[0].annotationTitle = unescape(annotation[0].annotationTitle);
    this.commonDataService.showRightPanel.next(true);
    var breadcrumb = annotation[0].breadCrumb.split('~')
    this.navData.crumbData = [];
    for (var i = 0; i < breadcrumb.length - 1; i++) {
      this.navData.crumbData.push(breadcrumb[i]);
    }
    this.commonDataService.breadcrumbPath.next(annotation[0].breadCrumb);
    this.commonDataService.navDataContentPage.next(this.navData.crumbData);
    this.commonDataService.annotationUpdateSource.next("MyAnnotation");
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
    this.commonDataService.currentParagraph.next(breadcrumb[breadcrumb.length - 1]);
    this.commonDataService.currentParagraphId.next(annotation[0].paragraphId);
    this.commonDataService.annotationContent.next(annotation[0]);
    this.commonDataService.rightOverlayOption.next("Add Annotation");
  }

  NavigateTo(url, id, topic, paraId) {
    if (topic != "20 Glossary") {
      if ((!url?.startsWith("/") && url?.split("/").length < 3) || (url?.startsWith("/") && url?.split("/").length <= 3)) {
        url = "/" + url?.split("/")[1] + "/" + url?.split("/")[2] + "/" + id;
      }
    }
    else {
      url = "/" + url?.split("/")[1] + "/" + url?.split("/")[2] + "/" + paraId;
    }
    this.route.navigateByUrl(url);
  }


}

export interface myAnnotations {
  id: string
  AnnotationTitle: string;
  Annotation: string;
  Location: string;
  Date: Date;
  ParagraphId: string;
  AnnotationsURL: string;
}
